import AddressBook from '../../addressBook';
/* eslint-disable import/no-cycle */
import Allotments from '../../account/allotments/Allotments';
import CurrentAllotments from '../../account/allotments/CurrentAllotments';
import FutureAllotments from '../../account/allotments/FutureAllotments';
import UserManagementPage from '../../userManagement/UserManagementPage';

import { allAdmin, allExceptInvoiceOnly } from '../../util/rolePermissions';

const accountRoutes = [
  {
    path: '/account/allotments',
    title: 'allotments.route',
    component: Allotments,
    nav: false,
    exact: false,
    limitToRoles: allAdmin,
    routes: [
      {
        path: '/account/allotments/current',
        title: 'allotments.current.route',
        component: CurrentAllotments,
        exact: true,
        titleSubCopy: 'currentAllotments',
        disableWhenEmpty: 'currentAllotments',
        limitToRoles: allAdmin
      },
      {
        path: '/account/allotments/future',
        title: 'allotments.future.route',
        component: FutureAllotments,
        exact: true,
        titleSubCopy: 'futureAllotments',
        disableWhenEmpty: 'futureAllotments',
        limitToRoles: allAdmin
      }
    ]
  },
  {
    path: '/account/manage',
    title: 'userManagement.route',
    component: UserManagementPage,
    nav: true,
    exact: true,
    limitToRoles: allAdmin
  },
  {
    path: '/account/address-book',
    title: 'addressBook.route',
    component: AddressBook,
    nav: true,
    exact: true,
    limitToRoles: allExceptInvoiceOnly
  }
];

export default accountRoutes;
